"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _ExpandMoreRounded = _interopRequireDefault(require("@material-ui/icons/ExpandMoreRounded"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getBootstrapInput = function getBootstrapInput(getInputStyle) {
  return (0, _styles.withStyles)(function (theme) {
    return {
      input: getInputStyle(theme)
    };
  })(_InputBase["default"]);
};

var CustomeSelect = (0, _styles.withStyles)(function (theme) {
  return {
    icon: {
      top: "calc(50% - 14px)"
    }
  };
})(_Select["default"]);

function OutlinedSelect(_ref) {
  var value = _ref.value,
      options = _ref.options,
      inputStyle = _ref.inputStyle,
      menuStyle = _ref.menuStyle,
      rest = _objectWithoutProperties(_ref, ["value", "options", "inputStyle", "menuStyle"]);

  var getInputStyle = function getInputStyle(theme) {
    var defaultInputStyle = {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #e0e0e0',
      fontSize: 13,
      padding: '10px 30px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow'])
    };
    return _objectSpread({}, defaultInputStyle, {}, inputStyle);
  };

  var BootstrapInput = getBootstrapInput(getInputStyle);
  return _react["default"].createElement(_FormControl["default"], null, _react["default"].createElement(CustomeSelect, _extends({
    value: value,
    IconComponent: function IconComponent() {
      return _react["default"].createElement(_ExpandMoreRounded["default"], {
        style: {
          position: "absolute",
          top: "8px",
          right: "4px",
          pointerEvents: "none"
        }
      });
    }
  }, rest, {
    input: _react["default"].createElement(BootstrapInput, null)
  }), options.map(function (option) {
    return _react["default"].createElement(_MenuItem["default"], {
      style: _objectSpread({
        fontSize: "13px"
      }, menuStyle),
      value: option.value,
      key: option.value
    }, option.label);
  })));
}

OutlinedSelect.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    label: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })),
  value: _propTypes["default"].string,
  inputStyle: _propTypes["default"].object,
  menuStyle: _propTypes["default"].object
};
OutlinedSelect.defaultProps = {
  options: [],
  value: '',
  inputStyle: {},
  menuStyle: {}
};
var _default = OutlinedSelect;
exports["default"] = _default;